import React from 'react';
import ReactDOM from 'react-dom/client';
// Chart.js v4+ requires explicit controller/scale/element registration. The
// `chart.js/auto` entrypoint registers everything (Line/Bar/Doughnut +
// CategoryScale/LinearScale + standard elements). Without this import, every
// react-chartjs-2 chart in the app throws at mount time. Until 2026-06-02
// this stayed hidden because all chart components had `hasData ? <Chart/> :
// <empty>` guards — Ruth UAT surfaced it when she clicked History on an item
// that actually had price-history data so the chart mounted for real (GH #169).
import 'chart.js/auto';
import './App.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
